import { currentBusinessDate } from "./timezone";

// Business date follows the deployment/depo timezone, never UTC serialization.
const currentDate = () => currentBusinessDate();
export default currentDate;
